type Props = {
  items: { id: string; label: string }[];
};

export default function ArticleToc({ items }: Props) {
  return (
    <nav aria-label="文章目录" className="rounded-lg border border-background-200 bg-background-50 p-5">
      <p className="flex items-center gap-2 border-b border-background-200 pb-3 text-xs font-medium tracking-widest text-foreground-500">
        <i className="ri-list-check-2" aria-hidden="true"></i>
        本篇目录
      </p>
      <ul className="mt-3 space-y-1">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className="group flex items-start gap-2 rounded-md px-2 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-foreground-300 group-hover:bg-primary-500" aria-hidden="true"></span>
              <span className="leading-snug">{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}